import { useQuery, QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

//! Test Only
import { createQuoteResponseMapping } from "../../mapping/createQuoteResponseMapping.js";
//---

const queryClient = new QueryClient();

const fetchQuoteData = async () => {
  try {
    // const isDev = import.meta.env.VITE_API_IN_DEV_MODE;
    // Get the mocked response data, map that and return it for
    // store in the cache.
    // const createQuoteResponse = lazy(
    //   () => import("../../data/mock/create-quote-response-mock-data.js")
    // );

    // const mappedData = createQuoteResponseMapping(createQuoteResponse());
    // queryClient.setQueryData([queryKeys.QUOTE_DATA_GET], mappedData || {});

    //* TODO: isDev PRE-DEPLOY
    const isDev = false;

    if (isDev === true && import.meta.env.MODE === "development") {
      import("../../data/mock/create-quote-response-mock-data.js")
        .then((module) => {
          const createQuoteResponse = module.createQuoteResponse;
          const mappedData = createQuoteResponseMapping(createQuoteResponse());
          queryClient.setQueryData(
            [queryKeys.QUOTE_DATA_GET],
            mappedData || {}
          );
        })
        .catch((error) => {
          console.log("Error loading mock data: ", error);
        });
    }

    //* return from TanStack Query Cache.
    const requestResponse = queryClient.getQueryData([
      queryKeys.QUOTE_DATA_GET,
    ]);
    return requestResponse;
  } catch (ex) {
    console.error(ex);
  }
};

export const useGetQuote = () =>
  useQuery({
    queryKey: [queryKeys.QUOTE_DATA_GET],
    queryFn: async () => await fetchQuoteData(),
    staleTime: Infinity,
  });
